export default __webpack_public_path__ + "static/media/in-tn.4add5854.svg";